import { defineStore } from 'pinia'

export const useAppStore = defineStore('app', {
    state: () => ({
        theme: 'light',

        openSearchResultsInNewTab: true,

        lightbox: {
            visible: false,
            images: []
        }
    }),

    getters: {},

    actions: {
        applyThemeClass() {
            document.documentElement.classList.toggle('dark', this.theme === 'dark')
        },

        isValidTheme(theme) {
            return ['light', 'dark'].includes(theme)
        },

        setTheme(theme) {
            if (this.isValidTheme(theme)) {
                this.theme = theme
                localStorage.setItem('theme', theme)
                this.applyThemeClass()
            }
        },

        toggleTheme() {
            this.theme = this.theme === 'dark' ? 'light' : 'dark'
            localStorage.setItem('theme', this.theme)
            this.applyThemeClass()
        },

        initTheme() {
            const savedTheme = localStorage.getItem('theme')
            const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches

            const themeToSet = this.isValidTheme(savedTheme) ? savedTheme : (prefersDark ? 'dark' : 'light')
            this.setTheme(themeToSet)
            this.applyThemeClass()
        },

        toggleOpenSearchResultsInNewTab() {
            this.openSearchResultsInNewTab = !this.openSearchResultsInNewTab
        },

        setLightboxImages(images) {
            this.lightbox.images = images
        },

        toggleLightbox(visible) {
            this.lightbox.visible = visible
        }
    }
})
